import { useEffect } from "react";
import { useApiQuery } from "../../../../common/infrastructure/hooks/useApiQuery";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";
import { showCustomConfirmDialog } from "../../../../common/components/dialogs/AppConfirmDialog";

interface IStripeConnectStatus {
  isConnected: boolean;
  maskedAccountId: string | null;
}

interface IStripeConnectUrl {
  url: string;
}

export const useStripeConnectSection = () => {
  const {
    data: status,
    refetch: refetchStatus,
    isFetching: isFetchingStatus,
  } = useApiQuery<IStripeConnectStatus>({
    queryKey: [endpointsMetadata.stripeConnect.getStatus],
    endpoint: endpointsMetadata.stripeConnect.getStatus,
    globalIsLoading: false,
    retry: false,
  });

  const {
    data: connectUrlData,
    refetch: fetchConnectUrl,
    isFetching: isFetchingUrl,
  } = useApiQuery<IStripeConnectUrl>({
    queryKey: [endpointsMetadata.stripeConnect.getConnectUrl],
    endpoint: endpointsMetadata.stripeConnect.getConnectUrl,
    enabled: false,
    globalIsLoading: false,
  });

  const { mutate: disconnect, isLoading: isDisconnecting } = useApiMutation({
    onSuccess: () => {
      refetchStatus();
    },
  });

  useEffect(() => {
    if (connectUrlData?.url) {
      window.open(connectUrlData.url, "_blank");
    }
  }, [connectUrlData]);

  useEffect(() => {
    const handleFocus = () => {
      refetchStatus();
    };
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [refetchStatus]);

  const handleConnect = () => {
    fetchConnectUrl();
  };

  const handleDisconnect = () => {
    showCustomConfirmDialog(
      "Сигурни ли сте, че искате да спрете връзката със Stripe? Обектите ви няма да могат да приемат плащания чрез Stripe, докато не свържете акаунт отново.",
      () => {
        disconnect({
          endpoint: endpointsMetadata.stripeConnect.disconnect,
          method: "delete",
          successMessage: "Stripe акаунтът беше успешно отвързан.",
        });
      },
      () => {},
      "warning",
      "Да, отмени",
      "Отказ",
    );
  };

  return {
    isConnected: status?.isConnected ?? false,
    maskedAccountId: status?.maskedAccountId ?? null,
    isFetchingStatus,
    isFetchingUrl,
    isDisconnecting,
    handleConnect,
    handleDisconnect,
    refetchStatus,
  };
};
